module.exports = {"150802001":"团结街道","150802002":"车站街道","150802003":"先锋街道","150802004":"解放街道","150802005":"新华街道","150802006":"东环街道","150802007":"铁南街道","150802008":"西环街道","150802009":"北环街道","150802013":"金川街道","150802014":"汇丰街道","150802100":"狼山镇","150802101":"新华镇","150802102":"干召庙镇","150802103":"乌兰图克镇","150802104":"双河镇","150802105":"城关镇","150802106":"白脑包镇","150802200":"曙光乡","150802201":"八一乡","150802400":"狼山农场","150802401":"临河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150802.json
// module id = 547
// module chunks = 0